/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { Badge } from "antd";
import {
  Collapse,
  Form,
  Flex,
  Row,
  Col,
  Space,
  Card,
  message,
} from "antd";
import { Input, Button, Table, Typography } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { accessColumn } from "./model";
import useColumnSettings from "../../../hooks/useColumnSettings";
import useAccessPageState from "../../../hooks/useAccessPageState";
import ActiveStatusItem, {
  ACTIVE_STATUS_DEFAULT,
  withDefaultStatus,
} from "../../../components/form/ActiveStatusItem";
import "./MyPage.css";
// import OptionService from "../../../service/ERP/Options.service";
// import dayjs from 'dayjs';
import FGservice from "../../../service/ERP/FG.service";
// const opService = OptionService();
const productservice = FGservice();
const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};
const FGAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      productservice
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => {
          const { data } = res.data;

          setAccessData(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    };

    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      runSearch(forcedValues);
      return;
    }

    form.validateFields().then((v) => {
      runSearch(v);
    });
  };

  const handleClear = () => {
    clearState();
    form.resetFields();
    form.setFieldValue("active_status", ACTIVE_STATUS_DEFAULT);

    const nextPagination = restoreDefaultPagination();

    handleSearch({ active_status: ACTIVE_STATUS_DEFAULT }, nextPagination);
  };

  const hangleAdd = () => {
    navigate("manage/create", {
      state: {
        config: {
          ...mngConfig,
          title: "Create FG",
          action: "create",
        },
      },
    });
  };

  const handleEdit = (data) => {
    // setManageConfig({...manageConfig, title:"แก้ไข Sample Request", action:"edit", code:data?.srcode});
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Edit FG",
          action: "edit",
          code: data?.id,
        },
      },
    });
  };

  /* โหมดดูอย่างเดียว — เปิดหน้าเดียวกับแก้ไขแต่ปิดการแก้ไขทั้งหน้า */
  const handleView = (data) => {
    navigate("manage/view", {
      state: {
        config: {
          ...mngConfig,
          title: "View FG",
          action: "view",
          code: data?.id,
        },
      },
    });
  };

  const handleDelete = (data) => {
    // startLoading();
    // ctmService.deleted(data?.dncode).then( _ => {
    //     const tmp = accessData.filter( d => d.dncode !== data?.dncode );
    //     setAccessData([...tmp]);
    // })
    // .catch(err => {
    //     console.log(err);
    //     message.error("Request error!");
    // });
  };

  const init = async () => {
    getData({});
  };

  useEffect(() => {
    const restored = restoreState();

    /* ถ้ายังไม่เคยเลือกสถานะไว้ ให้เริ่มที่ "เปิดการใช้งาน" */
    const values = withDefaultStatus(restored?.searchValues);
    form.setFieldsValue(values);

    handleSearch(values, restored?.tablePagination);
    return async () => {
      //console.clear();
    };
  }, []);

  const getData = () => {
    handleSearch();
  };

  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      bordered={false}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <>
            <br />
              <Form form={form} layout="vertical" autoComplete="off">
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item
                      label="FG Code"
                      name="fg_code"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter FG Code" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item
                      label="FG Thai Name"
                      name="fg_name"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter FG Thai Name" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      label="FG English Name"
                      name="fg_nameEN"
                      onChange={handleSearch}
                    >
                      <Input placeholder="Enter FG English Name" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item name="code" label="Code" onChange={handleSearch}>
                      <Input placeholder="Enter Code" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      label="ชื่อบรรจุภัณฑ์"
                      name="pk_name"
                      onChange={handleSearch}
                    >
                      <Input placeholder="กรอกชื่อ บรรจุภัณฑ์" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      label="ชื่อฝาปิด"
                      name="lid_name"
                      onChange={handleSearch}
                    >
                      <Input placeholder="กรอกชื่อ ฝาปิด" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      label="ชื่ออื่นๆ"
                      name="etc_name"
                      onChange={handleSearch}
                    >
                      <Input placeholder="เลือก ชื่ออื่นๆ" />
                    </Form.Item>
                  </Col>
                  <ActiveStatusItem onChange={handleSearch} />
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    {/* Ignore */}
                  </Col>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        icon={<SearchOutlined />}
                        onClick={() => handleSearch()}
                      >
                        ค้นหา
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        danger
                        icon={<ClearOutlined />}
                        onClick={() => handleClear()}
                      >
                        ล้าง
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
          showArrow: false,
        },
      ]}
    />
  );
  const allColumns = accessColumn({ handleEdit, handleDelete, handleView });
  /* คอลัมน์ที่แสดง ผู้ใช้เลือกเองได้ ระบบจำไว้ใน cookie ของเครื่องนี้ */
  const { columns: column, settingsButton } = useColumnSettings(
    "fg_access_cols",
    allColumns
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            List of Finished Goods
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end">
          {settingsButton}
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            Create FG
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="product-access">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
          {FormSearch}
        <Card>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                title={() => TitleTable}
                size="small"
                rowKey="product_code"
                columns={column}
                dataSource={accessData}
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default FGAccess;
